import React from "react";
import MenuItemsDynamic from "./MenuItemsDynamic";

const NavMenuDynamic = ({ menus, isClicked, closeMobileMenu }) => {

  return (
    <ul className={isClicked ? "menus-multi active" : "menus-multi"}>
      {menus.map((menu, index) => {
        const depthLevel = 0;
        return <MenuItemsDynamic item={menu} key={index} depthLevel={depthLevel} closeMobileMenu={closeMobileMenu} />;
      })}
    </ul>
  );
};

export default NavMenuDynamic;